<template>
    <span class="paginate">
      <button @click="this.$emit('moreOffres')" v-if="this.pagination.current < this.pagination.page">
        {{ $t("message.plus_offres") }} ({{ this.pagination.current * this.api.per_page }}/{{ this.pagination.total }})
      </button>
    </span>
</template>
<script>
export default {
  name: 'PaginationView',  
  props: ['offres', 'pagination', 'api'],
  methods : {

  },
  mounted() {
  },
}
</script>
<style scoped>
.paginate {
  display: block; width:100%; text-align: center; margin-bottom:30px;
}
button { 
  background: #242424;
  display: inline-flex;
  width: auto;
  color: white;
  padding: 10px 30px;
  border-radius: 100px;
  border: none;
  margin: auto;
  cursor: pointer;
  transition:all .4s ease-in-out;
}
button:hover {
  background:#FBBA00;
  color:#242424;
}
</style> 